import Cookies from "js-cookie";

// Making a workspace the current one, in one place: the sidebar's switcher and the plan popup both
// use it. Everything that depends on the workspace listens for "workspace-changed".
export const switchWorkspace = (workspace) => {
  localStorage.setItem("activeWorkspace", JSON.stringify(workspace));
  localStorage.setItem("activeWorkspaceId", workspace.id.toString());
  Cookies.remove("selected_org_id");
  Cookies.set("selected_org_id", workspace.id.toString(), { expires: 365 });
  window.dispatchEvent(new CustomEvent("workspace-changed", { detail: workspace }));
};

// The signed-in user's permission in the current workspace, from the workspace list ("owner" is the
// admin who created it; an invited admin is "admin").
export const currentWorkspacePermission = () => {
  try {
    const id = String(Cookies.get("selected_org_id") || "");
    const list = JSON.parse(localStorage.getItem("cachedWorkspaces") || "[]");
    return list.find((w) => String(w.id) === id)?.permission;
  } catch (_) {
    return undefined;
  }
};
